// Search here. https://remixicon.com/

export const icons = {
    "da-document": "ri-book-line",
    "da-documents": "ri-book-2-line",
    "da-grid": "ri-table-line",
    "da-prompts": "ri-quill-pen-ai-line",
    "da-role": "ri-user-settings-line",
    "da-active": "ri-checkbox-circle-line",
    "da-inactive": "ri-close-circle-line",
    "da-agent": "ri-chat-1-line",
    "da-history": "ri-history-line",
    "da-keywords": "ri-key-line",
    "da-conical": "ri-database-line",
    "da-municipalities": "ri-building-2-line",
    "da-municipality-categories": "ri-price-tag-3-line",
    "da-departments": "ri-building-line",
    "da-districts": "ri-road-map-line",
    "da-provinces": "ri-map-line",
}
